/**
 * Tb_Rn_Sys_Objects.EditFormWidth → CSS genişliği (#458).
 *
 * Değer serbest metin ("600px", "80%", "70vw", "min(800px, 90vw)"). Tarayıcının kabul
 * etmediği değer (ör. "abc") yok sayılır ve diyalog kendi varsayılan genişliğinde açılır;
 * yalnız sayı yazılmışsa piksel kabul edilir. Taşma diyalog tarafında 95vw ile kesilir.
 */
export function normalizeDialogWidth(raw: string | null | undefined): string | null {
  const v = (raw ?? '').trim();
  if (!v) return null;
  if (/^\d+(\.\d+)?$/.test(v)) return `${v}px`;
  const supports =
    typeof CSS !== 'undefined' && typeof CSS.supports === 'function' ? CSS.supports('width', v) : null;
  if (supports === null) return /^\d+(\.\d+)?(px|%|vw|rem|em)$/.test(v) ? v : null;
  return supports ? v : null;
}
